import React, { useEffect, useRef, useState } from "react";
import Modal from "./Modal";
import TextArea from "./TextArea";
import TextButton from "./TextButton";
import FormError from "./FormError";

function ConfirmDialog({
    open,
    title,
    eyebrow,
    message,
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    variant = "danger",
    requireReason = false,
    reasonLabel = "Reason",
    reasonPlaceholder = "Why are you doing this? (1–500 chars)",
    onConfirm,
    onClose,
    error,
}) {
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);
    const [localErr, setLocalErr] = useState(null);
    const reasonRef = useRef(null);

    useEffect(() => {
        if (open) {
            setReason("");
            setLocalErr(null);
            setSubmitting(false);
        }
    }, [open]);

    const submit = async (e) => {
        e?.preventDefault?.();
        setLocalErr(null);
        if (requireReason) {
            const trimmed = reason.trim();
            if (!trimmed) {
                setLocalErr("Reason is required.");
                return;
            }
            if (trimmed.length > 500) {
                setLocalErr("Reason must be 500 characters or fewer.");
                return;
            }
        }
        setSubmitting(true);
        try {
            await onConfirm?.(requireReason ? reason.trim() : undefined);
        } finally {
            setSubmitting(false);
        }
    };

    const displayed = error || localErr;

    return (
        <Modal
            open={open}
            onClose={submitting ? undefined : onClose}
            eyebrow={eyebrow}
            title={title}
            initialFocus={requireReason ? reasonRef : undefined}
            footer={
                <>
                    <TextButton variant="ghost" onClick={onClose} disabled={submitting}>
                        {cancelLabel}
                    </TextButton>
                    <TextButton
                        variant={variant}
                        onClick={submit}
                        loading={submitting}
                    >
                        {confirmLabel}
                    </TextButton>
                </>
            }
        >
            {message && (
                <p style={{ margin: 0, color: "var(--color-text-muted)", fontSize: "var(--fs-md)" }}>
                    {message}
                </p>
            )}
            {requireReason && (
                <TextArea
                    ref={reasonRef}
                    label={reasonLabel}
                    required
                    value={reason}
                    onChange={setReason}
                    maxLength={500}
                    placeholder={reasonPlaceholder}
                    rows={3}
                />
            )}
            {displayed && <FormError>{displayed}</FormError>}
        </Modal>
    );
}

export default ConfirmDialog;
